<template>
    <v-alert
        v-if="newMessages"
        color="accent" dense text v-ripple
        class="pointer" border="left"
        icon="mdi-message-alert-outline"
        @click="goToChats"
    >
        {{ $t('common.no_read_messages') }}
    </v-alert>
</template>

<script>
export default {
    name: "NewMessages",
    computed: {
        newMessages(vm = this) {
            return vm.account?.counter?.messages > 0 || false
        },
    },
    methods: {
        goToChats() {
            const vm = this
            let accountType = vm.account.accountType
            vm.$router.push({name: `${accountType}.chats`})
        },
    }
}
</script>

<style scoped>

</style>